import React from 'react'
import { sanitiseSummernoteText } from '../../../../utils/Helperfunctions'

export default function RenderHtml({data, className=''}) {
    return (
        data?.length ? <div className={`render-html ${className}`} style={{wordBreak: 'break-word'}} dangerouslySetInnerHTML={{__html:sanitiseSummernoteText(data?.replace(/\n/g,'<br/>')) }} /> : null
    )
}
